import { render } from "./News29.vue?vue&type=template&id=44842bf2"
import script from "./News29.vue?vue&type=script&lang=js"
export * from "./News29.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__